import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/index.js";
import React, { useCallback, useEffect, useState } from "react";
import { closeModal } from "../../../store/features/modal.js";
import { Button, Modal, Pagination, Stack, Thumbnail } from "@shopify/polaris";
import { OPEN_MODAL_COLLECTION } from "../../../constants/modalTypes.js";
import { useAppQuery } from "../../../hooks/index.js";
import { FileMinor, ImageMajor } from "@shopify/polaris-icons";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux.js";

interface CollectionByHandle {
  products: {
    pageInfo: {
      endCursor: string
      startCursor: string
      hasPreviousPage: boolean
      hasNextPage: boolean
    }
  }
}

const CollectionModal = () => {
  const dispatch = useAppDispatch();
  const { isOpen, modalType, modalData } = useAppSelector((state) => state.modal);
  const [cursor, setCursor] = useState(null)
  const [products, setProducts] = useState([])

  const {  isFetching, data } = useAppQuery<CollectionByHandle>({
    url: `/api/products/collection/${modalData?.collection?.handle}?${cursor ? 'cursor=' + cursor : ''}`,
    reactQueryOptions: {
      enabled: !!modalData?.collection?.handle,
      onSuccess(data) {
        setProducts(data.products.edges)
      }
    },
    fetchInit: {}
  });

  const handleClose = useCallback(() => {
    dispatch(closeModal());
    setProducts([])
    setCursor(null)
  }, []);

  const handleNext = useCallback(() => {
    setCursor(`${data?.products?.pageInfo.endCursor}:next`)
  }, [setCursor, data?.products?.pageInfo.endCursor])

  const handlePrevious = useCallback(() => {
    setCursor(`${data?.products?.pageInfo.startCursor}:previous`)
  }, [setCursor, data?.products?.pageInfo.startCursor])

  return (
    <Modal
      open={isOpen && modalType === OPEN_MODAL_COLLECTION}
      onClose={handleClose}
      title={modalData?.collection?.title}
    >
      <Modal.Section>
        <Stack vertical>
          {
            products.map(product => (
              <div key={product?.node?.id}>
                <Stack>
                  <Thumbnail
                    source={product?.node?.featuredImage?.url || ImageMajor}
                    alt={product?.node?.title}
                    size={"small"}
                  />
                  <span>{product?.node?.title}</span>
                </Stack>
              </div>
            ))
          }
        </Stack>
      </Modal.Section>
      <Modal.Section>
        <Stack distribution={"center"}>
          {isFetching ? <Button loading /> :
            <Pagination
              hasPrevious={data?.products?.pageInfo?.hasPreviousPage}
              onPrevious={handlePrevious}
              hasNext={data?.products?.pageInfo?.hasNextPage}
              onNext={handleNext}
            />
          }
        </Stack>
      </Modal.Section>
    </Modal>
  );
};

export default CollectionModal;